// extracted by mini-css-extract-plugin
export default {"bodyMetricsTable":"szSQgsznR4h1rFCLyTFo"};